import { createStorefrontApiClient } from '../Services/StoreFrontApiClient';
import { ProductFee, GlobalProductOptionsConfiguration, DecorationTypeKey, ProductFeeConfiguration } from './Product.DecoTypeDeclaration';
import { getSelectedProductDecorationType, getGlobalProductOptionsConfiguration } from './Product.DecoTypes';

export const getSelectedDecorationTypeFeeConfiguration = (
  productOptionsConfiguration:GlobalProductOptionsConfiguration, 
  selectedDecoTypeFee: string ): Array<ProductFeeConfiguration> | null => {

  const isHardGoodsProductType = Merchology.ProductDetails.isHardGoodsProductType;

  if(!Merchology.ProductDetails.isALCPricingProduct) {
    return null;
  }

  let feeObject = null;
  //Temporal Key Mapping until using the noramlized value keys
  switch (selectedDecoTypeFee) {
    case DecorationTypeKey.DECORATION_TYPE_SCREEN_PRINT: {
      feeObject = productOptionsConfiguration.decoration_types[DecorationTypeKey.DECORATION_TYPE_SCREEN_PRINT];
      break;
    }
    case DecorationTypeKey.DECORATION_TYPE_DIGITAL_PRINT: {
      feeObject = productOptionsConfiguration.decoration_types[DecorationTypeKey.DECORATION_TYPE_DIGITAL_PRINT];
      break;
    }
    case DecorationTypeKey.DECORATION_TYPE_LASER_ENGRAVED: {
      feeObject = productOptionsConfiguration.decoration_types[DecorationTypeKey.DECORATION_TYPE_LASER_ENGRAVED];
      break;
    }
    case DecorationTypeKey.DECORATION_TYPE_DEBOSSED: {
      feeObject = productOptionsConfiguration.decoration_types[DecorationTypeKey.DECORATION_TYPE_DEBOSSED];
      break;
    }
    case DecorationTypeKey.DECORATION_TYPE_HEAT_TRANSFER: {
      feeObject = productOptionsConfiguration.decoration_types[DecorationTypeKey.DECORATION_TYPE_HEAT_TRANSFER];
      break;
    }
  }

  if(!feeObject || !isHardGoodsProductType) {
    return null;
  }

  const feeCategoryConfiguration = feeObject.product_fees_categories.filter((feeCategory) => feeCategory.title === 'hardgoods');

  if(!feeCategoryConfiguration.length || !feeCategoryConfiguration[0].fees) {
    return null;
  }
  
  return feeCategoryConfiguration[0].fees;
}

export const getProductFeeByHandle = async (feeHandle: string): Promise<ProductFee> => {
  const productQuery = {
      query: `query {
        product (handle: \"${feeHandle}\") {
          id
          title
          handle
          vendor
          description
          productType
          tags 
          variants(first: 1) {
            nodes {
              id
              price { 
                amount
                currencyCode
              }
            }
          }
        }
      }`
  };

  const storefrontClient = createStorefrontApiClient();

  const productQueryResponse = await storefrontClient.post('', productQuery)
    .catch(error => {
      console.error(error);
      
      return { 
        success: false, 
        error_message: error.message
      };
    });

  let productQueryData = productQueryResponse;

  if (!productQueryData || (productQueryData.success === false) || !productQueryData.data) {
    return null;
  }

  productQueryData = productQueryData.data.product;

  const product = { 
    product_id: productQueryData.id,
    variant_id: productQueryData.variants.nodes[0].id,
    title:  productQueryData.title,
    handle: productQueryData.handle,
    price: productQueryData.variants.nodes[0].price.amount,
    description: productQueryData.description
  };

  return product;  
}

export const getFeeVariants = async () => {
  const productOptionsConfiguration = await getGlobalProductOptionsConfiguration();
  const queryElement = $('input[name="properties[_Decoration type]"]:checked');
    
  if (queryElement.length === 0) {
    return;
  }

  const selectedDecorationTypeKey = getSelectedProductDecorationType();

  const selectedProductTypeFees = getSelectedDecorationTypeFeeConfiguration(
    productOptionsConfiguration,
    selectedDecorationTypeKey
  );

  // Only ALC supported type is Hardgoods for now.
  if(!Merchology.ProductDetails.isHardGoodsProductType || !selectedProductTypeFees || !selectedProductTypeFees.length) {
    return;
  }

  const feeVariantsListData = [] as any;

  for (const feeConfiguration of selectedProductTypeFees) {
    const productFee = await getProductFeeByHandle(feeConfiguration.handle);

    feeVariantsListData.push({
      feeConfiguration,
      productFee
    });
  }

  return feeVariantsListData;
}

const showProductFees = (feesDataList: Array<any>) => {
  const alcPricingPDPFeeWarningTemplate = `
    * This product may incur a set up fee of {{setup_fee_price}}
    and will require a decoration run fee of up to {{run_fee_price}}/unit.
  `;

  $('.alc-pricing .pdp-message').text('');

  let setupFee = null as ProductFee;
  let runFee = null as ProductFee;

  for(const feeData of feesDataList) {
    switch (feeData.feeConfiguration.fee_type) {
      case 'alc-setup-fee': {
        setupFee = BigNumber(feeData.productFee.price).toFixed(2).toString();
        let currentALCPricingFeeWarning = $('.alc-pricing .pdp-message').first().text();
        
        if(currentALCPricingFeeWarning == "") {
          $('.alc-pricing .pdp-message').text(alcPricingPDPFeeWarningTemplate);
          currentALCPricingFeeWarning = $('.alc-pricing .pdp-message').first().text();
        }
        
        currentALCPricingFeeWarning = currentALCPricingFeeWarning.replace('{{setup_fee_price}}', '$' + setupFee);
        $('.alc-pricing .pdp-message').text(currentALCPricingFeeWarning);
        break;
      }
      case 'alc-run-fee': {
        runFee = BigNumber(feeData.productFee.price).toFixed(2).toString();
        let currentALCPricingFeeWarning = $('.alc-pricing .pdp-message').first().text();
        
        if(currentALCPricingFeeWarning == "") {
          $('.alc-pricing .pdp-message').text(alcPricingPDPFeeWarningTemplate);
          $('.setup-fee-info--tooltip').attr('data-original-title', alcPricingPDPFeeWarningTemplate);
          currentALCPricingFeeWarning = $('.alc-pricing .pdp-message').first().text();
        }
        currentALCPricingFeeWarning = currentALCPricingFeeWarning.replace('{{run_fee_price}}', '$' + runFee);
        $('.alc-pricing .pdp-message').text(currentALCPricingFeeWarning);
        $('.setup-fee-info--tooltip').attr('data-original-title', currentALCPricingFeeWarning);
        break;
      }
    }
  }
};

export const showSelectedDecorationFees = async () => {
  const showALCPricingMessage = function showALCPricingMessage() {
    getFeeVariants()
    .then(alcPricingFeesData => {
      showProductFees(alcPricingFeesData);
    });
  }

  $('input[name="properties[_Decoration type]"]').on('change', showALCPricingMessage);
}

export const findCartLineItemByVariantId = async (variantId: string) => {

  const cartData = await axios.get('/cart.js')

  if(!cartData || !cartData.data.items || !cartData.data.items.length) {
    return null;
  }

  const foundLineItem = cartData.data.items.find((item: any) => item.variant_id.toString() === variantId);
  return foundLineItem;
}

export const addProductOptionsLineitemsToCart = async () => {
  const alcPricingFeesData = await getFeeVariants();
  const cartAddEndpoint = '/cart/add.js';
  const feeVariantsToAddLineItems = [] as any;

  if(!alcPricingFeesData || !alcPricingFeesData.length) {
    return Promise.resolve();
  }
  
  for(const feeData of alcPricingFeesData) {
    const feeDataConfiguration = feeData.feeConfiguration;
    let isFeeAlreadyAdded = false;
    let feeVariantQuantity = 1;

    switch(feeDataConfiguration.fee_type) {
      case 'alc-run-fee': {
        const selectedSizeVariantSelector = $('.ProductSizeInfo.selected');
        if(selectedSizeVariantSelector.length > 0) {
          const quantityInputSelector = selectedSizeVariantSelector.find('.numbers-row.productQty');
          const quantityInputValue = quantityInputSelector.find('input[id*="quantity-"]').val() as string;
          feeVariantQuantity = parseInt(quantityInputValue);
        }
        break;
      }
    }

    const feeAlreadyInCart = await findCartLineItemByVariantId(feeData.feeConfiguration.variant_id);
    if(feeAlreadyInCart && feeAlreadyInCart.id) {
      console.log('Run fee with same variant id found.');
      isFeeAlreadyAdded = true;
    }

    // Add only one setup fee / run fee per decoration type per order
    // Quantities of the run fee will be adjusted later in the cart
    if(isFeeAlreadyAdded) {
      console.log('Fee already added to the cart. Skip to add it again.');
      continue;
    }

    feeVariantsToAddLineItems.push({
      id: feeData.feeConfiguration.variant_id,
      quantity: feeVariantQuantity,
      properties: {
        _alc_pricing: true,
        _alc_fee_type: feeDataConfiguration.fee_type,
        _alc_charge_type: feeDataConfiguration.charge_type,
      }
    })
  }

  if(!feeVariantsToAddLineItems.length) {
    return Promise.resolve();
  }

  return axios.post(cartAddEndpoint, 
    { items: feeVariantsToAddLineItems },  
    {
      headers: {
        'Content-Type': 'application/json'
      } 
    }
  );

}